import { InjectionToken } from '@angular/core';

export interface CloudPlatformConfig {
  apiBaseUrl: string;
}

export const CLOUD_PLATFORM_CONFIG = new InjectionToken<CloudPlatformConfig>('CloudPlatformConfig');
